import {isTouchScreen} from "core/utils/utils";
import {MODAL_REVIEW} from "../../../core/modals";

export function init() {
	const $container = $('#reviewsContainer');
	$container.on('click', '[rel=show-review]', function (e) {
		e.preventDefault();
		const $reviewItem = $(this).closest('[rel=review-item]');
		MODAL_REVIEW.show($reviewItem.data('id'), $reviewItem.data('index'), $container.data('filter'));
	});

	if (!isTouchScreen()) {
		const initialDelay = 1000;
		const slidersInterval = 200;
		const transitionDuration = 1000;
		const autoplayInterval = 5000;
		const sliders = createSliders('.main-reviews-col', transitionDuration, autoplayInterval);
		setTimeout(() => startSliders(sliders, slidersInterval), initialDelay);

		$container.hover(function () {
			sliders.forEach(s => s.pause());
		}, function () {
			sliders.forEach(s => s.unpause());
		});
	}

	/** @return {VerticalSlider[]} */
	function createSliders(selector, transitionDuration, autoplayInterval) {
		const sliders = [];
		$(selector).each(function (i) {
			const slider = new VerticalSlider(this);
			// slider.direction = 'prev';
			slider.transitionDuration = transitionDuration;
			slider.autoplayInterval = autoplayInterval;
			sliders.push(slider);
		});
		return sliders;
	}

	/**
	 * @param {VerticalSlider[]} sliders
	 * @param {number} interval
	 */
	function startSliders(sliders, interval) {
		sliders.forEach((slider, i) => {
			if (i == 0) {
				slider.startAutoplay();
			} else {
				setTimeout(() => {
					slider.startAutoplay();
				}, i*interval);
			}
		});
	}
}

class VerticalSlider {
	_paused = false;
	_sliding = false;

	direction = 'next';
	autoplayInterval = 2000;
	transitionDuration = 1000;

	constructor(selector) {
		this.$el = $(selector);
	}

	slideNext() {
		if (this._sliding) return;
		const $slides = this.getSlides();
		if ($slides.length < 3) return;
		const $slide = $slides.first();
		$slide
			.css('transitionDuration', (this.transitionDuration/1000) + 's')
			.css('marginTop', -$slide.outerHeight(true));
		this._sliding = true;
		setTimeout(() => {
			$slide
				.css('transitionDuration', '0s')
				.css('marginTop', '')
				.appendTo(this.$el);
			this._sliding = false;
		}, this.transitionDuration);
	}

	slidePrev() {
		if (this._sliding) return;
		const $slides = this.getSlides();
		if ($slides.length < 3) return;
		const $slide = $slides.last();
		this._sliding = true;
		$slide
			.prependTo(this.$el)
			.css('transitionDuration', '0s')
			.css('marginTop', -$slide.outerHeight(true));
		$slide[0].offsetHeight; // Trigger a reflow, flushing the CSS changes
		$slide
			.css('transitionDuration', (this.transitionDuration/1000) + 's')
			.css('marginTop', 0);
		setTimeout(() => {
			this._sliding = false;
		}, this.transitionDuration);
	}

	startAutoplay() {
		this._autoplaySlide();
		setInterval(() => {
			this._autoplaySlide();
		}, this.autoplayInterval);
	}

	_autoplaySlide() {
		if (!this._paused) {
			if (this.direction == 'prev') {
				this.slidePrev();
			} else {
				this.slideNext();
			}
		}
	}

	/** @return {JQuery} */
	getSlides() {
		return this.$el.children();
	}

	pause() {
		this._paused = true;
	}

	unpause() {
		this._paused = false;
	}
}


// WEBPACK FOOTER //
// ./modules/landing/sections/reviews.js